import 'oasi-security';
import 'oasi-main-theme/dist/oasi-main-theme.css';
import 'oasi-bpm-history/dist/oasiBpmHistory.css';
import 'oasi-widgets/dist/index.css';
import 'angular-toastr/dist/angular-toastr.css';
import 'angular-block-ui/dist/angular-block-ui.css';
import './index.scss';
import * as angular from 'angular';
import 'angular-animate';
import 'angular-cookies';
import 'angular-touch';
import 'angular-sanitize';
import 'angular-messages';
import 'angular-aria';
import 'angular-resource';
import 'angular-ui-bootstrap';
import 'angular-ui-router';
import 'angular-filter';
import 'oasi-widgets';
import 'oasi-bpm-rest';
import 'oasi-nsi-rest';
import 'orders-rest';
import 'angular-block-ui';
import 'jquery';
import 'angular-toastr';
import 'ng-file-upload';
import 'isogd-file-rest';
import 'fast-json-patch';
import 'oasi-bpm-history';
import 'oasi-solar-rest';
import { NewOrderComponent } from './newOrder/newOrder';
import { selectFilterCoEx } from './filters/selectFilterSc';
import { file } from './file/file';
import { OrderCardComponent } from './orderCard/orderCard';
import { fileInFn } from './file/fileInFn';
import { InstructionReadOnlyCardComponent, InstructionReadOnlyTaskComponent } from './instruction/instructionReadOnly';
import { ResultsComponent } from './result/results';
import { ResultEditorComponent, ResultAcceptEditorComponent } from './result/resultEditor';
import { EditOrderController } from './editOrder/editOrder';
import { fileInFnEd } from './file/fileInFnEd';
import { СancellController } from './cancel/cancel';

let module = angular.module('orders.document', ['ngAnimate',
    'ngCookies',
    'ngTouch',
    'ngSanitize',
    'ngMessages',
    'ngAria',
    'ngResource',
    'angular.filter',
    'ui.bootstrap',
    'ui.router',
    'toastr',
    'blockUI',
    'isogd.file.rest',
    'oasi.bpm.rest',
    'oasi.nsi.rest',
    'oasi.solar.rest',
    'oasi.widgets',
    'oasi.bpm.history',
    'orders.rest',
    'ngFileUpload',
    'oasi-security'
]);

module
.controller('EditOrderController', EditOrderController)
.controller('СancellController', СancellController)
.component('newOrder', NewOrderComponent)
.component('orderCard', OrderCardComponent)
.component('instructionReadOnlyCard', InstructionReadOnlyCardComponent)
.component('instructionReadOnlyTask', InstructionReadOnlyTaskComponent)
.component('results', ResultsComponent)
.component('resultEditor', ResultEditorComponent)
.component('resultAcceptEditor', ResultAcceptEditorComponent)
.component('fileLd', file)
.component('fileInFn', fileInFn)
.component('fileInFnEd', fileInFnEd)
.filter('selectFilterCoEx', selectFilterCoEx)
.config(['blockUIConfig', blockUIConfig]);

function blockUIConfig(blockUIConfig: any) {
    blockUIConfig.autoBlock = false;
    blockUIConfig.message = '';
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/index.ts